<template functional>
  <div class="form-field tw-flex tw-flex-row tw-w-full md:tw-w-auto" :class="[data.class,data.staticClass]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
      name: 'FormFieldRow',
  };
</script>
